import { useState } from "react";

type Column<T> = {
  header: string;
  accessor: (row: T) => any;
};

type CopyTableButtonProps<T> = {
  data: T[];
  columns: Column<T>[];
  fileName?: string; // optional (future use)
};

export function CopyTableButton<T>({ data, columns }: CopyTableButtonProps<T>) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!data?.length) return;

    // Header
    const header = columns.map((col) => col.header);

    // Rows
    const rows = data.map((row) =>
      columns.map((col) => {
        const value = col.accessor(row);
        return value ?? "";
      }),
    );

    // Convert to tab-separated (Excel-friendly)
    const tableData = [header, ...rows].map((row) => row.join("\t")).join("\n");

    navigator.clipboard.writeText(tableData);

    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <button
      onClick={handleCopy}
      className="text-sm px-3 py-1 border rounded-md hover:bg-gray-100"
    >
      {copied ? "✅" : "📋"}
    </button>
  );
}
